import { filterClasses } from "@swivl-mono/helpers";
import { LocationVarKey, SpotData, SpotDataButton, SpotDataButtonStyle, SpotDataHeaderSection, SpotListingItem } from "@swivl-mono/types";
import { Link } from "react-router-dom";

export function SpotPageHeader(props: SpotData) {
  return (
    <div className="spot-page-header sticky top-0 left-0 z-10 mx-auto w-full text-white">
      <SpotPageImage {...props} />
      <SpotPageShade />
      <div className="relative z-20 flex flex-col items-center justify-center pt-20 pr-3 pb-10 pl-3">
        {props.avatarUri && (
          <div className="relative h-20 w-20 overflow-hidden rounded-lg bg-white">
            <img className="h-full w-full object-cover" src={props.avatarUri} alt={`${props.heading} Logo`} />
          </div>
        )}
        {props.heading && <h1 className="mt-2 text-center text-2xl font-semibold text-white">{props.heading}</h1>}
        {props.subHeading && <div className="mt-2 text-center text-white">{props.subHeading}</div>}
        <SpotPageHeaderSection {...props} />
      </div>
    </div>
  );
}

interface SpotPageHeaderSectionProps {
  headerSections?: SpotDataHeaderSection[][];
}

export function SpotPageHeaderSection(props: SpotPageHeaderSectionProps) {
  const sections = props.headerSections;
  if (!sections || !sections.length) return null;

  return (
    <div className="flex flex-col items-center justify-center text-white">
      {" "}
      {sections.map((sectionGroup: SpotDataHeaderSection[], index: number) => {
        const className =
          sectionGroup.length > 1 && index > 0
            ? "grid md:grid-cols-2 sm:grid-cols-1 gap-x-10 gap-y-1 md:gap-y-5 pt-1 relative z-20 md:pl-15 md:pr-15 sm:pl-5 sm:pr-5"
            : "grid grid-cols-1 gap-x-10 gap-y-1 pt-1 relative z-20 md:pl-15 md:pr-15 sm:pl-5 sm:pr-5";
        return (
          <div key={index} className={className}>
            {sectionGroup.map((section: SpotDataHeaderSection) => {
              if (section.isLink) {
                return (
                  <a key={section.id} className="mk1 flex flex-col" href={section.href} target={section.target || "_self"}>
                    {section.title && (
                      <h4
                        className={
                          section.center
                            ? "text-mdsm mb-1 text-center font-bold whitespace-pre-line text-white"
                            : "text-mdsm mb-1 text-center font-bold whitespace-pre-line text-white md:text-left"
                        }
                      >
                        {section.title}
                      </h4>
                    )}
                    {section.content && (
                      <p
                        className={
                          section.center
                            ? "text-mdsm text-center whitespace-pre-line text-white"
                            : "text-mdsm text-center whitespace-pre-line text-white md:text-left"
                        }
                      >
                        {section.content}
                      </p>
                    )}
                  </a>
                );
              }
              return (
                <div key={section.id} className="flex flex-col">
                  {section.title && (
                    <h4
                      className={
                        section.center
                          ? "text-mdsm mb-1 text-center font-bold whitespace-pre-line text-white"
                          : "text-mdsm mb-1 text-center font-bold whitespace-pre-line text-white md:text-left"
                      }
                    >
                      {section.title}
                    </h4>
                  )}
                  {section.content && (
                    <p
                      className={
                        section.center
                          ? "text-mdsm text-center whitespace-pre-line text-white"
                          : "text-mdsm text-center whitespace-pre-line text-white md:text-left"
                      }
                    >
                      {section.content}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

export function SpotPageImage(props: SpotData) {
  return (
    <div className="absolute top-0 right-0 bottom-0 left-0 z-0 w-auto overflow-hidden bg-transparent text-white">
      <img
        alt={props.heading}
        className="z-0 h-full w-full bg-black object-cover"
        src={props.backgroundUri ? props.backgroundUri : "/self_storage_hallway.jpg"}
      />
    </div>
  );
}

export function SpotPageShade() {
  return <div className="absolute top-0 right-0 bottom-0.5 left-0 z-10 bg-linear-to-t from-[#000000cc] to-[#00000033]"></div>;
}

interface SpotLocationButtonProps {
  button: SpotDataButton;
  builderButton?: boolean;
}
export function SpotLocationButton(props: SpotLocationButtonProps) {
  const { button, builderButton } = props;
  if (builderButton) {
    const className = filterClasses(
      "text-mdsm flex h-11 w-full cursor-pointer flex-row items-center justify-center rounded-md py-[8px] transition-colors",
      button.style === SpotDataButtonStyle.PRIMARY
        ? `bg-primary text-primary-text hover:bg-primary-hover hover:text-primary-hover-text active:bg-primary-active active:text-primary-active-text`
        : `bg-secondary text-secondary-text hover:bg-secondary-hover hover:text-secondary-hover-text active:bg-secondary-active active:text-secondary-active-text`
    );
    return (
      <div className={className}>
        {button.icon && <span className="mr-2">{button.icon}</span>}
        {button.title}
      </div>
    );
  }
  const isFirstCharacterSlash = button.href?.charAt(0) === "/";
  if (isFirstCharacterSlash) {
    const className = filterClasses(
      "text-mdsm mb-[10px] flex h-11 w-full cursor-pointer flex-row items-center justify-center rounded-md py-[8px] transition-colors",
      button.style === SpotDataButtonStyle.PRIMARY
        ? `bg-primary text-primary-text hover:bg-primary-hover hover:text-primary-hover-text active:bg-primary-active active:text-primary-active-text`
        : `bg-secondary text-secondary-text hover:bg-secondary-hover hover:text-secondary-hover-text active:bg-secondary-active active:text-secondary-active-text`
    );
    return (
      <Link className={className} to={button.href!}>
        {button.icon && <span className="mr-2">{button.icon}</span>}
        {button.title}
      </Link>
    );
  }

  const className = filterClasses(
    "text-mdsm mb-[10px] flex h-11 w-full cursor-pointer flex-row items-center justify-center rounded-md py-[8px] transition-colors",
    button.style === SpotDataButtonStyle.PRIMARY
      ? `bg-primary text-primary-text hover:bg-primary-hover hover:text-primary-hover-text active:bg-primary-active active:text-primary-active-text`
      : `bg-secondary text-secondary-text hover:bg-secondary-hover hover:text-secondary-hover-text active:bg-secondary-active active:text-secondary-active-text`
  );
  return (
    <a className={className} href={button.href} target={button.target || "_blank"}>
      {button.icon && <span className="mr-2">{button.icon}</span>}
      {button.title}
    </a>
  );
}

interface SpotLocationItemProps {
  brandSlug?: string;
  item: SpotListingItem;
}

export function SpotLocationItem({ brandSlug, item }: SpotLocationItemProps) {
  return (
    <Link to={`/${brandSlug}/${item.variables[LocationVarKey.SpotLocationSlug]}/`} className="mb-5 flex w-full flex-row bg-white">
      <div className="relative h-20 w-20 overflow-hidden rounded-lg bg-slate-200">
        {item.variables[LocationVarKey.AvatarURL] && (
          <img className="h-full w-full object-cover" src={item.variables[LocationVarKey.AvatarURL]} alt={`${item.location.name}`} />
        )}
      </div>
      <div className="ml-4 flex flex-col items-start justify-center">
        <div className="text-base font-bold text-[#000000]">{item.location.name}</div>
        <div className="text-sm text-[#818181]">
          {item.variables[LocationVarKey.Address]} {item.variables[LocationVarKey.City]} {item.variables[LocationVarKey.State]}{" "}
          {item.variables[LocationVarKey.PostalCode]}
        </div>
        {/* <div className="text-xs text-[#818181]">{item.text}</div> */}
      </div>
    </Link>
  );
}
